// src/redux/reducers/ruleReducer.js
import { createSlice } from '@reduxjs/toolkit';
import { createRule } from '../../services/game.services';

const initialState = {
    rule: null,
    loading: false,
    error: null,
  };
  
  const ruleSlice = createSlice({
    name: 'rule',
    initialState,
    reducers: {
      createRuleRequest(state) {
        state.loading = true;
        state.error = null;
      },
      createRuleSuccess(state, action) {
        state.loading = false;
        state.rule = action.payload;
      },
      createRuleFailure(state, action) {
        state.loading = false;
        state.error = action.payload;
      },
    },
  });
  
  export const { createRuleRequest, createRuleSuccess, createRuleFailure } = ruleSlice.actions;
  
  export const addRule = (ruleData) => async (dispatch) => {
    dispatch(createRuleRequest());
    try {
      const response = await createRule(
        ruleData,
        JSON.parse(sessionStorage.getItem('myData'))
      );
      dispatch(createRuleSuccess(response.data));
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.status === 409) {
        errorMessage = 'A rule with the same identifier already exists.';
      }
      dispatch(createRuleFailure(errorMessage));
    }
  };
  
  export default ruleSlice.reducer;